import * as React from 'react';

import { UIHelper } from '../../utils/UIHelper';

export interface SwipeButtonRightButton {
    callback: () => void;
    classNameActive: string;
    className: string;
    stretchOnClick?: boolean;
}

export interface SwipeButtonProps extends React.Props<SwipeButton> {
    buttons: Array<SwipeButtonRightButton>;
    closeGroupMembers: (node: HTMLElement) => void;
    noneOpen: () => boolean;
    height: number;
    onClick?: () => void;
}

export interface SwipeButtonState {
    dragStartX: number;
    dragMargin: number;
    stretchIndex?: number;
}

export class SwipeButton extends React.Component<SwipeButtonProps, SwipeButtonState> {
    private static stretchTimeout: number = 1000;
    private static heightAfterStretch: number = 0;

    protected maxMargin: number;
    protected clickAllowed: boolean;
    protected domNode: HTMLElement;

    public close = (domNode: HTMLElement | null): void => {
        if (this.domNode != null && this.domNode !== domNode) {
            this.setState({
                dragStartX: 0,
                dragMargin: 0
            });
        }
    };

    public componentWillMount(): void {
        this.maxMargin = this.props.buttons.length * this.props.height;
        this.setState({
            dragStartX: 0,
            dragMargin: 0
        });
    }

    public componentDidMount(): void {
        this.domNode.setAttribute('touch-action', 'pan-y');
        window.addEventListener('pointerup', this.stopDragging, true);
        this.domNode.addEventListener('pointermove', this.dragging, true);
        this.domNode.addEventListener('pointerdown', this.startDragging, false);
    }

    public componentWillUnmount(): void {
        window.removeEventListener('pointerup', this.stopDragging, true);
        this.domNode.removeEventListener('pointermove', this.dragging, true);
        this.domNode.removeEventListener('pointerdown', this.startDragging, false);
    }

    public render(): JSX.Element {
        if (this.state.dragMargin === this.maxMargin) {
            // make sure only one member is open (multiple ones could be opened if user used multiple fingers)
            this.props.closeGroupMembers(this.domNode);
        }
        let paddingLeft: string = '100%';
        if (this.state.stretchIndex != null) {
            paddingLeft = '0';
        } else if (this.state.dragMargin > 0) {
            paddingLeft = 'calc(100% - ' + this.state.dragMargin + 'px)';
        }
        return (
            <div
                className={'core-swipe-button' + (this.state.dragStartX ? '' : ' core-swipe-button-idle')}
                style={{
                    height: this.state.stretchIndex != null ? SwipeButton.heightAfterStretch : this.props.height,
                    paddingLeft: paddingLeft,
                }}
                onClick={this.onClick}
                ref={this.setElement}
            >
                <div className="core-swipe-main-container" style={{left: -this.state.dragMargin}}>{this.props.children}</div>
                {this.props.buttons.map(this.getButton)}
            </div>
        );
    }

    protected getButton = (button: SwipeButtonRightButton, index: number): JSX.Element | null => {
        if (this.state.stretchIndex != null && index !== this.state.stretchIndex) {
            return null;
        }
        return (
            <div
                className={
                    'core-swipe-right ' +
                    ((this.state.dragMargin > (this.maxMargin * .5)) ? button.classNameActive : button.className) +
                    ((this.state.stretchIndex != null) ? ' core-swipe-right-streched' : '')
                }
                onClick={this.onButtonClick(button, index)}
                key={index}
                style={this.state.stretchIndex != null ? {width: '100%'} : {
                    width: (100 / this.props.buttons.length).toString() + '%',
                }}
            />
        );
    };

    protected onButtonClick = (button: SwipeButtonRightButton, index: number) => async (event: React.MouseEvent<HTMLElement>) => {
        UIHelper.stopEvent(event);
        if (this.state.dragMargin === this.maxMargin) {
            if (button.stretchOnClick) {
                this.setState(jQuery.extend({}, this.state, {stretchIndex: index}));
                await new Promise<void>((resolve, reject) => {setTimeout(resolve, SwipeButton.stretchTimeout); });
            }
            button.callback();
        }
    };

    protected setElement = (node: HTMLDivElement): void => {
        this.domNode = node;
    };

    protected startDragging = (event: PointerEvent): void => {
        this.clickAllowed = this.props.noneOpen();
        if (!this.clickAllowed) {
            this.props.closeGroupMembers(this.domNode);
        }
        if (this.state.dragMargin === this.maxMargin) {
            this.setState({
                dragStartX: event.pageX + this.maxMargin,
                dragMargin: this.maxMargin
            });
        } else {
            this.setState({
                dragStartX: event.pageX,
                dragMargin: 0
            });
        }
    };

    protected stopDragging = (event: PointerEvent): void => {
        this.setState({
            dragStartX: 0,
            dragMargin: (this.state.dragMargin >= (this.maxMargin * .5)) ? this.maxMargin : 0
        });
    };

    protected dragging = (event: PointerEvent): void => {
        if (this.state.dragStartX) {
            const newMargin: number = this.state.dragStartX - event.pageX;
            if (newMargin < 0) {
                this.setState({
                    dragStartX: event.pageX,
                    dragMargin: 0
                });
            } else if (newMargin <= this.maxMargin) {
                this.setState({
                    dragStartX: this.state.dragStartX,
                    dragMargin: newMargin
                });
            }
        }
    };

    protected onClick = (event: React.MouseEvent<HTMLElement>): void => {
        if (
            this.props.onClick != null &&
            this.clickAllowed
        ) {
            this.props.onClick();
        }
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/core-swipe-button/SwipeButton.tsx